import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UserService as ApiUserService } from '../../../api/index';
import { SmsTimerService } from '../../../services/index';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationPhoneRenterService {

  private timerSubject = new BehaviorSubject<number>(0);
  public timer$ = this.timerSubject.asObservable();

  private timeSubject = new BehaviorSubject<number>(0);
  public time$ = this.timeSubject.asObservable();

  constructor(
    private apiUserService: ApiUserService,
    private smsTimerService: SmsTimerService
  ) {
    this.smsTimerService.timer.subscribe(time => {
      this.timeSubject.next(time);
    })
  }

  get timer(): number {
    return this.timerSubject.value;
  }

  set timer(value: number) {
    this.smsTimerService.onSmsTimer(value);
    this.timerSubject.next(value);
  }

  sendConfirmationCode(phone_number: string) {
    return this.apiUserService.userRegistration2faCodePost({
      phone_number,
      country_code: '375'
    });
  }

  verifyCode({ code, phone: phone_number, requestId: request_id }) {
    return this.apiUserService.userRegistration2faVerifyPost({
      code,
      phone_number,
      request_id
    })
  }

  reset() {
    this.smsTimerService.offSmsTimer();
  }
}
